export default "__VITE_ASSET__CTCbGP7o__"